import { useToggleTypes } from 'hooks';

export default (editor) => {
  const cm = editor.Commands;

  cm.add('custom-code-modal', {
    run(editor) {
      const target = editor.getModel();

      target.get('onShow')(useToggleTypes.showCustomCodeModal);
    },
  });
};
